import { slideToggle } from './slide-toggle';

document.addEventListener('DOMContentLoaded', () => {
    setupMobileMenu();
    // setupDesktopMenu();
});

function setupMobileMenu() {
    // Add border div to menu container
    const menuContainer = document.querySelector('.sidebar .menu-main-menu-container');
    if (menuContainer) {
        const borderDiv = document.createElement('div');
        borderDiv.className = 'border';
        menuContainer.appendChild(borderDiv);
    }

    // Handle clicks outside of the sidebar menu - to close it
    document.addEventListener('click', e => {
        const openMenus = document.querySelectorAll('.sidebar-menu .sidebar.open');
        if (!openMenus.length) {
            return;
        }

        e.preventDefault();
        openMenus.forEach(menuSidebarElement => {
            menuSidebarElement.parentElement.querySelector('.toggle.open').classList.remove('open');
            menuSidebarElement.classList.remove('open');
        });
    });

    // Prevent clicks inside the sidebar menu from closing it (see handler above)
    document.querySelectorAll('.sidebar-menu').forEach(sidebarMenuElement =>
        sidebarMenuElement.addEventListener('click', e => {
            e.stopPropagation();
        })
    );

    // Toggle the related sidebar menu
    document.querySelectorAll('.sidebar-menu .toggle').forEach(toggleElement =>
        toggleElement.addEventListener('click', e => {
            e.stopPropagation();
            toggleElement.classList.toggle('open');
            const sidebar = toggleElement.parentElement.querySelector('.sidebar');
            sidebar.classList.toggle('open');
            
            // Toggle announcement bar visibility
            const announcementBar = document.querySelector('#announcement-bar');
            if (announcementBar) {
                if (sidebar.classList.contains('open')) {
                    announcementBar.classList.add('hidden');
                } else {
                    announcementBar.classList.remove('hidden');
                }
            }
        })
    );

    // Toggle submenu
    document.querySelectorAll('.sidebar-menu .menu-item-has-children .arrow').forEach(arrowElement => {
        arrowElement.addEventListener('click', e => {
            const submenu = e.currentTarget.parentElement.querySelector('.sub-menu');
            
            // If submenu is visible, close it
            if (submenu.style.display === 'block') {
                e.currentTarget.classList.remove('active');
                slideToggle(submenu, 300);
                
                // After animation completes, ensure display is none
                setTimeout(() => {
                    submenu.style.display = 'none';
                }, 300);
            } else {
                // If submenu is hidden, open it
                e.currentTarget.classList.add('active');
                submenu.style.display = 'block';
                slideToggle(submenu, 300);
            }
            
            e.stopPropagation();
        });
    });

    // Hide submenu on load
    document.querySelectorAll('.sidebar-menu .sub-menu').forEach(subMenuElement =>
        subMenuElement.style.display = 'none'
    );
}

// document.addEventListener('DOMContentLoaded', function() {
//     // Select all sub-menus that are children of mega-menu items in navigation-desktop
//     const megaMenuSubmenus = document.querySelectorAll('#navigation-desktop li.mega-menu > .sub-menu');
    
//     megaMenuSubmenus.forEach(submenu => {
//         // Create the outer wrapper div (sub-menu)
//         const outerWrapper = document.createElement('div');
//         outerWrapper.className = 'mega-sub-menu';
        
//         // Create the inner wrapper div (wrap)
//         const innerWrapper = document.createElement('div');
//         innerWrapper.className = 'wrap';
        
//         // Clone the submenu
//         const submenuClone = submenu.cloneNode(true);
        
//         // Remove sub-menu class from the original ul and any nested elements
//         submenuClone.classList.remove('sub-menu');
//         submenuClone.querySelectorAll('.sub-menu').forEach(element => {
//             element.classList.remove('sub-menu');
//         });
        
//         // Get the parent li element
//         const parentLi = submenu.parentNode;
        
//         // Build the new structure
//         innerWrapper.appendChild(submenuClone);
//         outerWrapper.appendChild(innerWrapper);
        
//         // Replace the original submenu with the new structure
//         parentLi.replaceChild(outerWrapper, submenu);
//     });
// });


document.addEventListener('DOMContentLoaded', function() {
    // First, select all mega-menu items and add indexed classes
    const megaMenuItems = document.querySelectorAll('#navigation-desktop li.mega-menu');
    megaMenuItems.forEach((item, index) => {
        item.classList.add(`mega-menu-0${index + 1}`);
    });

    // Then proceed with the existing submenu modifications
    const megaMenuSubmenus = document.querySelectorAll('#navigation-desktop li.mega-menu > .sub-menu');
    
    megaMenuSubmenus.forEach(submenu => {
        // Create the outer wrapper div (sub-menu)
        const outerWrapper = document.createElement('div');
        outerWrapper.className = 'mega-sub-menu';
        
        // Create the inner wrapper div (wrap)
        const innerWrapper = document.createElement('div');
        innerWrapper.className = 'wrap';

        // Create the image container div
        const imageContainer = document.createElement('div');
        imageContainer.className = 'media';
        
        // Clone the submenu
        const submenuClone = submenu.cloneNode(true);
        
        // Change the immediate ul's class from 'sub-menu' to 'children'
        submenuClone.classList.remove('sub-menu');
        submenuClone.classList.add('children');
        
        // Find any nested ul.sub-menu elements and change their class to 'grandchildren'
        submenuClone.querySelectorAll('.sub-menu').forEach(element => {
            element.classList.remove('sub-menu');
            element.classList.add('grandchildren');
        });
        
        // Get the parent li element
        const parentLi = submenu.parentNode;
        
        // Build the new structure
        innerWrapper.appendChild(submenuClone);
        innerWrapper.appendChild(imageContainer);
        outerWrapper.appendChild(innerWrapper);
        
        // Replace the original submenu with the new structure
        parentLi.replaceChild(outerWrapper, submenu);
    });

    // Move images to their corresponding media containers
    const mediaContainer = document.querySelector('#navigation-desktop .mega-menu-media');
    if (mediaContainer) {
        const images = mediaContainer.querySelectorAll('img');
        images.forEach((img, index) => {
            const targetContainer = document.querySelector(`#navigation-desktop .mega-menu-0${index + 1} .media`);
            if (targetContainer) {
                targetContainer.appendChild(img.cloneNode(true));
            }
        });
        // Remove the original media container after moving all images
        mediaContainer.remove();
    }
});